module.exports = __webpack_public_path__ + "static/media/student.94c62511.png";